import styled from "styled-components";

export const Container = styled.div`
  margin-top: 20px;
`;

export const PedidoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 6px;
  padding: 16px 20px;
  margin-bottom: 10px;
  line-height: 1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
`;

export const PedidoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const PedidoId = styled.div`
  font-size: 18px;
  font-weight: bold;
`;
export const PedidoStatus = styled.span`
  font-size: 14px;
  color: #4caf50;
  font-weight: bold;
`;
export const PedidoBody = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;
export const PedidoData = styled.span`
  font-size: 14px;
  color: #aeaeae;
`;
export const PedidoValor = styled.span`
  font-size: 14px;
  color: #555;
  gap: 5px;
  display: flex;
  align-items: center;
  font-weight: bold;
`;
export const PedidoItens = styled.span`
  font-size: 14px;
  color: #555;
`;

export const DetalhesGrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-column-gap: 15px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
  }
`;

export const TimeLineContainer = styled.div`
  @media (max-width: 768px) {
    order: 2;
  }
`;

export const DetalhesPedidoContainer = styled.div`
  @media (max-width: 768px) {
    order: 1;
  }
`;
